/* RURU homepage — section behaviour (Shopify-safe). */
(function () {
  function init(root) {
    var scope = root && root.querySelector ? (root.querySelector('.ruru-home') || root) : document;
    if (!scope.querySelector) scope = document;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var $$ = function (s) { return Array.prototype.slice.call(scope.querySelectorAll(s)); };

    /* Scroll progress bar */
    var bar = scope.querySelector('.hp-progress');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'hp-progress';
      (scope.querySelector('.ruru-home') ? scope.querySelector('.ruru-home') : scope).appendChild(bar);
    }

    /* Directional + scale reveal variants */
    $$('.hp-split').forEach(function (sp) {
      sp.removeAttribute('data-r');
      var media = sp.querySelector('.hp-split-media');
      var body = sp.querySelector('.hp-split-body');
      var rev = sp.classList.contains('rev');
      if (media) media.setAttribute('data-r', rev ? 'right' : 'left');
      if (body) { body.setAttribute('data-r', rev ? 'left' : 'right'); body.style.setProperty('--rd', '140ms'); }
    });
    $$('.hp-feat, .hp-duo-card, .hp-tst').forEach(function (c) { c.setAttribute('data-r', 'scale'); });

    /* Staggered reveal */
    $$('.hp-features, .hp-split-list, .hp-stats, .hp-trust-inner, .hp-tst-grid, .hp-duo-wrap').forEach(function (group) {
      Array.prototype.slice.call(group.children).forEach(function (child, i) {
        if (child.hasAttribute('data-r')) child.style.setProperty('--rd', (i * 90) + 'ms');
      });
    });
    $$('.hp-split-list li').forEach(function (li, i) {
      li.setAttribute('data-r', '');
      li.style.setProperty('--rd', (i * 90) + 'ms');
    });

    var els = $$('[data-r]');
    if (reduce) {
      els.forEach(function (el) { el.classList.add('vis'); });
    } else {
      els.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.95) el.classList.add('vis');
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('vis'); io.unobserve(e.target); } });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { if (!el.classList.contains('vis')) io.observe(el); });
      setTimeout(function () {
        els.forEach(function (el) {
          if (getComputedStyle(el).opacity !== '1') {
            el.style.transition = 'none';
            el.classList.add('vis');
            el.style.opacity = '1'; el.style.transform = 'none'; el.style.filter = 'none';
          }
        });
      }, 1200);
    }

    /* Count-up for stats */
    var animateNum = function (el) {
      var raw = el.textContent.trim();
      var m = raw.match(/^([^\d]*)([\d.,]+)(.*)$/);
      if (!m) return;
      var pre = m[1], post = m[3];
      var target = parseFloat(m[2].replace(',', '.'));
      var decimals = (m[2].split('.')[1] || '').length;
      if (reduce || !isFinite(target)) { el.textContent = raw; return; }
      var dur = 1300, start = 0;
      var tick = function (t) {
        if (!start) start = t;
        var p = Math.min(1, (t - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = pre + (target * eased).toFixed(decimals) + post;
        if (p < 1) requestAnimationFrame(tick); else el.textContent = raw;
      };
      requestAnimationFrame(tick);
    };
    var statIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animateNum(e.target); statIO.unobserve(e.target); } });
    }, { threshold: 0.6 });
    $$('.hp-stat .n').forEach(function (el) { statIO.observe(el); });

    /* FAQ accordion */
    $$('[data-faq]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.hp-faq-item');
        var open = item.classList.contains('open');
        $$('.hp-faq-item').forEach(function (it) { it.classList.remove('open'); });
        if (!open) item.classList.add('open');
      });
    });

    /* Scroll progress */
    var ticking = false;
    var onScroll = function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var doc = document.documentElement;
        var st = window.scrollY || doc.scrollTop || document.body.scrollTop || 0;
        var max = (doc.scrollHeight || document.body.scrollHeight) - window.innerHeight;
        bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, st / max) : 0) + ')';
        ticking = false;
      });
    };
    if (!scope.__ruruScroll) {
      window.addEventListener('scroll', onScroll, { passive: true });
      scope.__ruruScroll = true;
    }
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ===== Cart drawer — standalone, binds once via document delegation ===== */
(function () {
  if (window.__ruruCartInit) return;
  window.__ruruCartInit = true;

  function drawer() { return document.querySelector('[data-cart-drawer]'); }

  function formatMoney(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
        return Shopify.formatMoney(cents, theme.moneyFormat);
      }
    } catch (e) {}
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) ? ' ' + Shopify.currency.active : '';
    return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2 }) + cur;
  }

  function render(cart) {
    var d = drawer(); if (!d) return;
    var itemsEl = d.querySelector('[data-cart-items]');
    var emptyEl = d.querySelector('[data-cart-empty]');
    var footEl = d.querySelector('[data-cart-foot]');
    var totalEl = d.querySelector('[data-cart-total]');
    var headCount = d.querySelector('[data-cart-headcount]');

    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      if (cart.item_count > 0) { b.textContent = cart.item_count; b.hidden = false; }
      else { b.hidden = true; }
    });
    if (headCount) headCount.textContent = cart.item_count > 0 ? (cart.item_count + (cart.item_count === 1 ? ' item' : ' items')) : '';

    if (!cart.items || cart.items.length === 0) {
      if (itemsEl) itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = '';
      if (footEl) footEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    if (footEl) footEl.hidden = false;
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, '_140x$1$2') : '';
        return '<div class="hp-cart-item" data-key="' + it.key + '" style="--ci-delay:' + (i * 70) + 'ms">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<div></div>') +
          '<div><div class="ci-title">' + it.product_title + '</div>' +
          '<div class="ci-price">' + formatMoney(it.final_price) + '</div>' +
          '<div class="ci-qty"><button type="button" data-ci-minus aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-ci-plus aria-label="Increase">+</button></div>' +
          '<button type="button" class="ci-remove" data-ci-remove>Remove</button></div>' +
          '<div class="ci-line">' + formatMoney(it.final_line_price) + '</div>' +
          '</div>';
      }).join('');
    }
  }

  function load() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(render).catch(function () {});
  }

  function changeLine(key, qty, rowEl) {
    if (qty === 0 && rowEl) rowEl.classList.add('removing');
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      setTimeout(function () { render(cart); }, qty === 0 ? 280 : 0);
    }).catch(function () {});
  }

  function open() {
    var d = drawer(); if (!d) return;
    d.classList.add('open');
    var panel = d.querySelector('.hp-cart-panel'); if (panel) panel.classList.add('is-open');
    var ov = d.querySelector('.hp-cart-overlay'); if (ov) ov.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    load();
  }
  function close() {
    var d = drawer(); if (!d) return;
    d.classList.remove('open');
    var panel = d.querySelector('.hp-cart-panel'); if (panel) panel.classList.remove('is-open');
    var ov = d.querySelector('.hp-cart-overlay'); if (ov) ov.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Document-level delegation — works no matter when/where the markup loads.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }
    var row = e.target.closest('.hp-cart-item');
    if (row) {
      var key = row.getAttribute('data-key');
      var qEl = row.querySelector('.ci-qty span');
      var q = qEl ? parseInt(qEl.textContent, 10) : 1;
      if (e.target.closest('[data-ci-plus]')) changeLine(key, q + 1);
      else if (e.target.closest('[data-ci-minus]')) changeLine(key, Math.max(0, q - 1), q - 1 === 0 ? row : null);
      else if (e.target.closest('[data-ci-remove]')) changeLine(key, 0, row);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('cart:refresh', load);
  document.addEventListener('cart:open', function () { open(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
})();
